/* Stylesheet */

.searchbar_container {
  display: flex;
  align-items: center;

  .searchbar {
    margin: 0px 12px 0px 0px;
    --border-radius: 42px;
    --box-shadow: var(--ion-box-shadow);
    --color: var(--ion-color-text-primary);
    --icon-color: var(--ion-color-icon-primary);
    --placeholder-color: var(--ion-color-text-disabled);
    --clear-button-color: var(--ion-color-text-disabled);
  }
}
